exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selector-container {\n  background-color: #303030;\n  display: inline-block;\n  width: 100%; }\n\n.selector-accent {\n  background-color: #a0a0a0;\n  display: inline-block;\n  width: 45%; }\n\n.selector {\n  width: 100%; }\n\n.graph {\n  position: relative;\n  max-width: 100vw;\n  max-height: 80vh; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Workspace/hyblab-migration/src/app/charte/charte.component.scss
// module id = ../../../../../src/app/charte/charte.component.scss
// module chunks = main